import type { IconProps } from './types';

export const Liquidation = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
    <path
      d="M8.44555 5.46484H6.24022c-1.28608 0-2.51948.51867-3.42887 1.4419-.90939.92323-1.42028 2.1754-1.42028 3.48106 0 1.3056.51089 2.5578 1.42028 3.481.90939.9233 2.14279 1.4419 3.42886 1.4419h8.37699"
      stroke="var(--color-quanta-icon)"
      strokeWidth="1.39235"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.68199 7.25415L8.44531 5.46399L6.68199 3.67383"
      stroke="var(--color-quanta-icon)"
      strokeWidth="1.39235"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.56226 10.5371H9.7676c1.2861 0 2.5195-.5187 3.4289-1.44189.9094-.92323 1.4202-2.1754 1.4202-3.48104 0-1.30565-.5108-2.55782-1.4202-3.48105-.9094-.92323-2.1428-1.441892-3.4289-1.441892H1.39063"
      stroke="var(--color-quanta-icon)"
      strokeWidth="1.39235"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.32583 8.7478L7.5625 10.538L9.32583 12.3281"
      stroke="var(--color-quanta-icon)"
      strokeWidth="1.39235"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
